import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useCart } from "react-use-cart";
import {
  Typography,
  Button,
  Card,
  CardActions,
  CardContent,
  Rating,
  Container, 
  CssBaseline,
  Box
} from "@mui/material";
import { FaCartShopping } from "react-icons/fa6";
import ImageFull from "../components/imageFull";
import Title from "../components/title";
import DescriptionFull from "../components/descriptionFull";
import DiscountedPrice from "../components/discountedPrice";
import Discount from "../components/discount";
import Price from "../components/price";
import SecondaryButton from "../components/secondaryButton";

export default function Details() {
  const [product, setProduct] = useState({});
  const [error, setError] = useState(null);
  const { addItem } = useCart();
  const { id } = useParams();
  const API_URL = "https://v2.api.noroff.dev/online-shop/" + id;

  useEffect(() => {
    async function getProduct() {
      try {
        const response = await fetch(API_URL);
        const result = await response.json();
        const APIdata = result.data;
        setProduct(APIdata);
      } catch (err) {
        setError("Sorry, something went wrong");
      }
    }
    getProduct();
  }, [API_URL]);

  // const hasDiscount = product.discountedPrice;
  const reviews = product.reviews;

  return (
    <>
     <CssBaseline />
    <Container maxWidth="sm">
    <Box sx={{  minheight: '90vh' }} >
      {error ? (
        <Link to="/products">
          <Button color="error">
            {error} <br />
            Back to the products
          </Button>
        </Link>
      ) : (
            <Card
              key={id}
              sx={{ backgroundColor: "#FBFAF8", maxWidth: 800, padding: {md: 2}, m: 5 }}
            >
              <ImageFull val={product.image?.url} />
              <CardContent>
                <Title val={product.title} />
                <DescriptionFull val={product.description} />
                {product.price !== product.discountedPrice ? (
                  <>
                    <DiscountedPrice val={product.discountedPrice} />
                    <Discount
                      val={Math.round(product.price - product.discountedPrice)}
                    />
                  </>
                ) : (
                  <Price val={product.price} />
                )}
                {reviews?.map((review, index) => (
                  <div key={index}>
                    <Typography
                      sx={{ mt: 2 }}
                      gutterBottom
                      variant="body2"
                      color="text.secondary"
                    >
                      {review.description} - {review.username}
                    </Typography>
                    <Typography component="legend"></Typography>
                    <Rating
                      key={`rating-${index}`}
                      name="read-only"
                      value={review.rating}
                      readOnly
                    />
                  </div>
                ))}
              </CardContent>
              <CardActions sx={{ display: 'flex', flexDirection: {xs: 'column', md: 'row'}, alignItems: {xs: 'center'}}}>
                  <Link to={"/products"}>
                    <SecondaryButton val={"Back to the products"} />
                  </Link>
                  <Button
                    onClick={() => addItem({ ...product })}
                    variant="contained"
                    color="secondary"
                  >
                    <FaCartShopping size={15} /> Add to Cart
                  </Button>
              </CardActions>
            </Card>
      )}
    </Box>
    </ Container>
    </>
  );
}
